import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingIndicatorService {
  readonly loadingStates = signal<Record<string, boolean>>({});

  toggleLoading(componentId: string, isLoading: boolean): void {
    this.loadingStates.update(states => ({ ...states, [componentId]: isLoading }));
  }

  stopAllLoading(): void {
    this.loadingStates.set({});
  }
}